import React, { useState, useEffect } from "react";
import axios from "axios";
import { useShoppingContext } from "../../../../context/ShoppingContext";
import { useAuth } from "../../../../context/AuthContext";
import "../Add.css"

const AddTiposHuevosForm = () => {
  const { fetchTiposHuevos, setShowAddEgg, showAddEgg, tiposHuevos } = useShoppingContext();
  const { authenticatedUser } = useAuth();
  const [formData, setFormData] = useState({
    nombre: "",
    userId: authenticatedUser?.id, // Assuming the user is authenticated
  });
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchTiposHuevos(); // Fetch the egg types when the form loads
  }, [fetchTiposHuevos]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/tipos-huevos`, formData);
      setMessage("Tipo de huevo agregado exitosamente");
      setFormData({
        nombre: "",
        userId: authenticatedUser.id,
      });
      fetchTiposHuevos(); // Fetch the updated list of egg types
    } catch (error) {
      setMessage("Error al agregar tipo de huevo");
      console.error("Error:", error);
    }
  };

  return (
    <div className="add-form-container">
      <div className="add-ave-form">
        <h2>Agregar Tipo de Huevo</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nombre">Nombre</label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
          </div>
          <div className="add-ave-form-buttons">
            <div
              onClick={() => setShowAddEgg(!showAddEgg)}
              className="btn btn-green-outline"
            >
              Regresar
            </div>
            <button type="submit" className="btn btn-green">
              Agregar
            </button>
          </div>
        </form>
        {message && <p>{message}</p>}

        {/* Lista de tipos de huevo ya agregados */}
        <div className="tipos-huevos-list">
          <h2>Mis tipos de huevo</h2>
          {tiposHuevos.map((tipo) => (
            <div key={tipo.id} className="tipo-huevo-card">
              <h3>{tipo.nombre}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AddTiposHuevosForm;
